import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aa6401c8df9599463a666790a7ecd6d97b from "./generated-8f1b5756-c0b3-4bd2-b19b-94cf94e51502.json";

import ab672d248d4a595a037cc242b528600e9b from "./generated-e3dd81e4-5b66-4fd7-8a7b-ba8388f857ca.json";

import abc05488e255dcb3bf864f5dcf66d1bc2b from "./generated-5124b19c-946b-4ecd-bd41-09177f2cbde7.json";

import a9e73f57da8d773752ef06dcf86362e90b from "./generated-53f1df0b-9ab9-4292-9bf6-ad55c04c3ee1.json";

import a64b09770ebaa8259e37ffce614765c22b from "./generated-1d77df14-3d71-43f6-bcd2-3ce227912601.json";

import a9d12f54c8e4bf20cf95c72f4ae4239e8b from "./generated-4b51271c-6261-4e23-a8f3-bf6ed1260d1c.json";

import aabec978c4e4f4ea56bb976dce3f891e3b from "./generated-46b759ef-2ee3-4350-9c49-b480a26cc8db.json";

import a092d9db1dc42f8598c84e242389a7b14b from "./generated-b820d22a-f64c-40a9-9763-ba5689e12fcc.json";

import ad0540398a0be082d580174f5e42c7ea2b from "./generated-4233cf95-c8ff-4c9e-bef0-4790d07ee899.json";

import a027d0f365cc0f99307f9a35d8c04dcfab from "./generated-f2ef904e-109e-48a4-865e-7bd988e94714.json";

import a98b0609a49be16a3db3bcd5b676734d0b from "./generated-b1aa54da-0c55-4570-9f4d-f14affdae9b4.json";

import ac4248c8560db2d46cf9ca726254455ebb from "./generated-6572e950-f6a3-4ff1-83d0-5cd305893a3e.json";

import a1ee3b775bfd78fbcbd977dee040caddeb from "./generated-22d7c5eb-c606-46b3-b94f-8039be540972.json";

import a63d5bd0fe1dd5601dcd8c39b3ef1e8d4b from "./generated-e6e5bcff-4206-44ba-bcba-b7a1c9ccd454.json";

import a4e0763cabcfcf9e8bd73a0a69a8ea976b from "./generated-5c304af8-cd23-462b-aabd-168d61095996.json";

import a05ae98b18caadb16f815b5b752522454b from "./generated-09b8531d-8009-4cea-978e-ed0d2a79cf6d.json";

import af4c2f8034274fd3381bcb9d5f6d3d921b from "./generated-27d8a500-e146-4782-ab47-076f39682fc8.json";

import ad4f318da8d98aa763c24ea9183f64c6ab from "./generated-cf1d709a-405f-4d8c-847e-bf12c611a860.json";

import abadb501d9dce5b5c8c1b49ba7ad56831b from "./generated-070ec9eb-db92-48fb-aa92-c0242c570d6f.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aa6401c8df9599463a666790a7ecd6d97b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(ab672d248d4a595a037cc242b528600e9b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(abc05488e255dcb3bf864f5dcf66d1bc2b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a9e73f57da8d773752ef06dcf86362e90b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a64b09770ebaa8259e37ffce614765c22b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9d12f54c8e4bf20cf95c72f4ae4239e8b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(aabec978c4e4f4ea56bb976dce3f891e3b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a092d9db1dc42f8598c84e242389a7b14b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ad0540398a0be082d580174f5e42c7ea2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a027d0f365cc0f99307f9a35d8c04dcfab);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a98b0609a49be16a3db3bcd5b676734d0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ac4248c8560db2d46cf9ca726254455ebb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a1ee3b775bfd78fbcbd977dee040caddeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a63d5bd0fe1dd5601dcd8c39b3ef1e8d4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a4e0763cabcfcf9e8bd73a0a69a8ea976b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a05ae98b18caadb16f815b5b752522454b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(af4c2f8034274fd3381bcb9d5f6d3d921b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ad4f318da8d98aa763c24ea9183f64c6ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(abadb501d9dce5b5c8c1b49ba7ad56831b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(af4c2f8034274fd3381bcb9d5f6d3d921b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */